<template>
  <div class="color-picker-wrapper inline-flex flex-col min-w-[190px] w-full">
    <span
      v-show="label"
      class="text-slate-600 text-sm font-semibold"
    >
      {{ label }}
    </span>
    <div v-if="loading">
      <div class="w-full h-10 bg-gray-300 rounded animate-pulse" />
    </div>
    <div
      v-else
      class="color-picker border border-gray-300 bg-white rounded h-10 overflow-hidden w-full"
    >
      <div
        class="flex flex-row justify-center min-w-[150px]"
      >
        <div class="font-bold text-xl pr-1 pl-2 pt-1">
          #
        </div>
        <input
          v-model="colorString"
          :disabled="disabled"
          type="text"
          placeholder="Select..."
          class="appearance-none border-none rounded pr-3 text-gray-700 leading-tight focus:outline-none bg-white focus:shadow-outline min-w-[100px]"
        >
      </div>
      <div class="h-full w-10">
        <color-picker
          v-if="!disabled"
          v-model:pure-color="currentColor"
          format="hex"
          disable-alpha
        />
      </div>
    </div>
    <span
      v-show="errorMessage"
      class="text-red-500 text-xs"
    >
      {{ errorMessage }}
    </span>
  </div>
</template>

<script>
import {ColorPicker} from "vue3-colorpicker";
import "vue3-colorpicker/style.css";
import tinycolor from "tinycolor2";

import {ref} from "vue";

export default {
  name: "CustomColorPicker",
  components: {ColorPicker},
  model: {
    prop: 'modelValue',
    event: 'change',
  },
  props: {
    /**
     * Model Value to update when selected
     */
     
    modelValue: {
      default: '',
      type: [String, null]
    },
    label: {
      type: String,
      default: ""
    },
    loading: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  emits: ['update:modelValue'],

  setup(props) {
    const currentColor = ref(props.modelValue);
    return {currentColor};
  },
  data() {
    return {
      colorString: "",
      errorMessage: ""
    };
  },
  watch: {
    currentColor(newColor) {
      this.$emit('update:modelValue', newColor);
      if(newColor){
        this.colorString = newColor.substring(1);
      }
    },
    colorString(newColor, oldColor) {
      if (newColor.startsWith('#')) {
        newColor = newColor.substring(1);
      }
      if (newColor !== oldColor) {
        const color = tinycolor(newColor);
        if (color.isValid() && color.getAlpha() === 1) {
          this.currentColor = "#" + newColor;
          this.errorMessage = "";
        } else if(newColor){
          this.errorMessage = "Enter a valid hex value";
        }
      }
    },
    modelValue(val) {
      this.currentColor = val;
    }
  },
  mounted() {
    const color = tinycolor(this.currentColor);
    if (color.isValid() && color.getAlpha() === 1) {
      if (this.currentColor.startsWith("#")) {
        this.colorString = this.currentColor.substring(1);
      } else {
        this.colorString = this.currentColor;
      }
    }
  },
};
</script>

<style scoped>
.color-picker {
  display: inline-flex;
  justify-content: space-between;
}

:deep(.vc-color-wrap) {
  height: 100%;
  width: 100%;
}
</style>
